import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteTrainingTypeModal({
  show,
  onHide,
  onDelete,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body style={{ textAlign: "center", padding: 25 }}>
        <div
          style={{
            width: 70,
            height: 70,
            background: "#fde2e2",
            borderRadius: 12,
            margin: "0 auto 15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#e11d48",
          }}
        >
          <FiTrash2 size={28} />
        </div>

        <h5 style={{ fontWeight: 600 }}>Confirm Delete</h5>
        <p style={{ color: "#6b7280" }}>
          This action cannot be undone.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
          <Button onClick={onHide} style={{ background: "#eee", border: "none" }}>
            Cancel
          </Button>
          <Button onClick={onDelete} style={{ background: "#ef4444", border: "none" }}>
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}